﻿import { Component, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalComponent } from 'ng2-bs3-modal';

import { State } from '../shared/types/state.type';
import { Topic } from '../shared/types/topic.type';
import { SubTopic } from '../shared/types/sub-topic.type';
import { Question } from '../shared/types/question.type';
import { QuestionContent } from '../shared/types/question-content.type';

import { TopicService } from '../shared/services/topic.service'
import { SubTopicService } from '../shared/services/sub-topic.service'
import { QuestionService } from '../shared/services/question.service'

import * as $ from 'jquery';

@Component({
  selector: 'question',
  templateUrl: './question.html',
  styleUrls: ['./question.css']
})

export class QuestionComponent {

  @ViewChild('addModal')
  addModal: BsModalComponent;

  @ViewChild('editModal')
  editModal: BsModalComponent;

  @ViewChild('deleteModal')
  deleteModal: BsModalComponent;

  topics: Topic[];
  selectedQuestion: Question;
  questions: Question[];
  questionStates: State[];
  questionContents: QuestionContent[];

  questionContent: QuestionContent;
  subTopics: SubTopic[];
  selectedQuestionStateRow: Number;

  selectedTopicId: number = null;
  selectedSubTopicId: number = null;
  originalSubTopicId: number = null;
  selectedQuestionId: number;
  newTopicName: string = null;
  errorMessage: string;
  responseMessage: string;
  questionResponseMessage: string;

  safetyChecked: boolean;
  enviroChecked: boolean;

  view: string = 'question';

  public options: Object = null;

  constructor(public _route: ActivatedRoute, public _router: Router, public _topicService: TopicService, public _subTopicService: SubTopicService, public _questionService: QuestionService) { }

  ngOnInit() {

    this.options = {
      key: 'NobA-9F1rH-7A-31=='
    };

    this._route.params.subscribe(params => {
        if (params["questionId"] != null) {

        this.loadQuestionContents(params["questionId"], params["topicId"], params["subTopicId"]);
      }

      if (params["subTopicId"] != null) {
        this.selectedTopicId = params["topicId"];
        this.selectedSubTopicId = params["subTopicId"] == 'null' ? null : params["subTopicId"];
        this._subTopicService.getSubTopicsByTopicId(this.selectedTopicId).subscribe((data: any[]) => {
          this.subTopics = data;
        });

        this._questionService.getQuestionsBySubTopicId(params["topicId"], params["subTopicId"]).subscribe((data: any[]) => {
            this.questions = data;
        });
      } else {

        let searchTerm = "*";

        if (params["searchTerm"] != null) {
          searchTerm = params["searchTerm"];
        }
        this._questionService.getQuestionsLike(searchTerm).subscribe((data: any) => {
            this.questions = data;
        });
      }
    });

    this.getTopics();

  }

  navigateToQuestionContent(questionId, topicId, subTopicId) {
      this.originalSubTopicId = this.selectedSubTopicId;

    this._router.navigate(["/questions/" + questionId + "/" + topicId + "/" + subTopicId]);
  }

  loadQuestionContents(questionId, topicId, subTopicId) {
    this.selectedQuestionId = questionId;

    this._questionService.getQuestion(questionId).subscribe((data: any) => {
      this.selectedQuestion = data;

      switch (this.selectedQuestion.TypeId) {
        case 1:
          this.safetyChecked = true;
          this.enviroChecked = false;
          break;
        case 2:
          this.safetyChecked = false;
          this.enviroChecked = true;
          break;
        case 3:
          this.safetyChecked = true;
          this.enviroChecked = true;
          break;
      }

    });

    this._questionService.getQuestionStates(questionId).subscribe((data: any[]) => {
      this.questionStates = data;
    });

    this._questionService.getQuestionContents(questionId).subscribe((data: any[]) => {
      this.questionContents = data;
      var selectedStateIndex = 0;

      if (this.questionContents.length > 0) {

        if (this.questionContents.filter(f => f.StateId == 46).length > 0) {
            this.questionContent = this.questionContents.filter(f => f.StateId == 46)[0];
            selectedStateIndex = 0;
        } else {
          this.questionContent = this.questionContents[0];
        }

        this.selectedTopicId = topicId;
   
        this.selectedSubTopicId = subTopicId;
        this.selectedQuestionStateRow = selectedStateIndex;
      }
    });

    this.view = 'questionContent';
  }

  getQuestionContentByStateId(stateId) {
    if (this.questionContents.length > 0) {
      this.questionContent = this.questionContents.filter(f => f.StateId == stateId)[0];
    }
  }

  getTopics() {
    this._topicService.getTopics().subscribe((data: any[]) => {
      this.topics = data;
    })
  }

  editQuestionContent() {
    this._questionService.postQuestionContent(this.questionContent).subscribe(data => {
      this.responseMessage = "Content Saved."
      this.showResponseMessage();
    })
  }

  cancelEdit() {
      this.selectedSubTopicId = this.originalSubTopicId;
      this._router.navigate(["/questions/" + this.selectedTopicId + "/" + this.originalSubTopicId]);
  }

  onTopicSelect(topicId) {

    this.selectedTopicId = topicId;
    this.selectedSubTopicId = null;
    this.originalSubTopicId = null;
    this.questions = null;

    this._subTopicService.getSubTopicsByTopicId(topicId).subscribe((data: any[]) => {
      this.subTopics = data;
    });

    this._questionService.getQuestionsBySubTopicId(this.selectedTopicId, this.selectedSubTopicId).subscribe((data: any[]) => {
        this.questions = data;
    });
  }

  onSubTopicSelect(subTopicId) {
    this._router.navigate(["/questions/" + this.selectedTopicId + "/" + subTopicId]);
  }

  clearSearch() {
      if (this.selectedTopicId || this.selectedSubTopicId) {
          this.selectedTopicId = null;
          this.selectedSubTopicId = null;
          this.originalSubTopicId = null;
          this.questions = null;

          this._questionService.getQuestionsLike("*").subscribe((data: any) => {
              this.questions = data;
          });
      }
  }

  editQuestion() {

    if (this.safetyChecked && this.enviroChecked) {
      this.selectedQuestion.TypeId = 3;
    } else if (!this.safetyChecked && this.enviroChecked) {
      this.selectedQuestion.TypeId = 2;
    } else if (this.safetyChecked && !this.enviroChecked) {
      this.selectedQuestion.TypeId = 1;
    }
  
    this._questionService.postQuestion(this.selectedQuestion).subscribe(data => {
      this.questionResponseMessage = "Question Saved.";
      this.showQuestionResponseMessage();
    });
  }

  deleteQuestion() {
    this._questionService.deleteQuestion(this.selectedQuestionId).subscribe(data => {
      this._router.navigate(["/questions"]);
    });
  }

  setClickedRow(index) {
    this.selectedQuestionStateRow = index;
  }

  onTypeChange(e, type) {
   
    switch (type) {
      case 1:
        if (e.target.checked) {
          this.safetyChecked = true;
        } else {
          this.safetyChecked = false;
        }
        break;
      case 2:
        if (e.target.checked) {
          this.enviroChecked = true;
        } else {
          this.enviroChecked = false;
        }
        break;
    }
  }

  onActiveChange(e) {
      this.errorMessage = "";
      if (e.target.checked) {
          var activeQuestions = this.questions.filter(q => q.Active);

          if (activeQuestions.length == 0) {
              this.selectedQuestion.Active = e.target.checked;
          }
          else {
              this.errorMessage = "An active question already exists under this topic/subtopic combination.";
          }
      }
      else {
          this.selectedQuestion.Active = e.target.checked;
      }
  }

  openAddNew() {
    this.view = "questionContent";
    this.selectedQuestion = new Question();
    this.selectedQuestion.TopicId = this.selectedTopicId;
    this.selectedQuestion.SubTopicId = this.selectedSubTopicId;
  }

  showResponseMessage() {
    $("#responseMessage").addClass("response-message");
    $("#responseMessage").show();

    setTimeout(function () { $("#responseMessage").hide(500); }, 1000);
  }

  showQuestionResponseMessage() {
    $("#questionResponseMessage").addClass("response-message");
    $("#questionResponseMessage").show();

    setTimeout(function () { $("#questionResponseMessage").hide(500); }, 1000);
  }

}
